<template>
  <div class="challenge-users-report">
    <div v-if="loading" class="challenge-report-fullscreen-loader">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>

    <div class="category-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click.prevent="close">
            <i class="ti-arrow-left"></i> {{ $t('general.back') }}
          </a>
        </p>
        <h4 style="margin:0;">{{ challengeTitle }}</h4>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <el-radio-group v-model="statusFilter" size="small" @change="loadUsers" style="margin-bottom:15px;">
          <el-radio-button label="">{{ $t('challengeCampaigns.allUsers') }}</el-radio-button>
          <el-radio-button label="IN_PROGRESS">{{ $t('challengeCampaigns.inProgressUsers') }}</el-radio-button>
          <el-radio-button label="COMPLETED">{{ $t('challengeCampaigns.completedUsers') }}</el-radio-button>
        </el-radio-group>

        <el-table :data="tableData" style="width:100%;" :empty-text="$t('gestiune.noData')" @row-click="onRowClick">
          <el-table-column :label="$t('challengeCampaigns.user')" min-width="180">
            <template slot-scope="p">
              {{ [p.row.firstname, p.row.lastname].filter(Boolean).join(' ') || p.row.email || ('#' + p.row.user_id) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('challengeCampaigns.progress')" width="140">
            <template slot-scope="p">{{ p.row.progress }} / {{ p.row.target }} ({{ p.row.progress_percentage }}%)</template>
          </el-table-column>
          <el-table-column :label="$t('orders.status')" width="120">
            <template slot-scope="p">{{ formatChallengeStatus(p.row.status) }}</template>
          </el-table-column>
          <el-table-column :label="$t('challengeCampaigns.startedAt')" min-width="150">
            <template slot-scope="p">{{ formatDateTime(p.row.started_at) || '—' }}</template>
          </el-table-column>
          <el-table-column :label="$t('challengeCampaigns.lastProgressAt')" min-width="150">
            <template slot-scope="p">{{ formatDateTime(p.row.last_progress_at) || '—' }}</template>
          </el-table-column>
          <el-table-column :label="$t('challengeCampaigns.completedAt')" min-width="150">
            <template slot-scope="p">{{ formatDateTime(p.row.completed_at) || '—' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { RadioGroup, RadioButton } from 'element-ui'
Vue.use(RadioGroup)
Vue.use(RadioButton)

export default {
  props: {
    route: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      loading: true,
      tableData: [],
      statusFilter: '',
      challengeTitle: ''
    }
  },
  computed: {
    challengeId () {
      const fromProp = this.route && this.route.params && this.route.params.challengeId
      const fromRouter = this.$route && this.$route.params && this.$route.params.challengeId
      return fromProp || fromRouter
    }
  },
  created () {
    this.challengeTitle = (this.route && this.route.query && this.route.query.title) || (this.$route.query && this.$route.query.title) || ''
    this.loadUsers()
  },
  methods: {
    formatChallengeStatus (status) {
      if (!status) return '—'
      const key = 'challengeCampaigns.status_' + status
      const translated = this.$t(key)
      return translated === key ? status : translated
    },
    loadUsers () {
      if (!this.challengeId) return
      this.loading = true
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        status: this.statusFilter || null,
        page: 1,
        pageSize: 100
      }
      this.apiRequest('/reports/challenges/' + this.challengeId + '/users', 'GET', data, (response) => {
        this.loading = false
        if (response.status) {
          this.tableData = response.data || []
          const challenge = (response.data_specials && response.data_specials.challenge) || response.challenge
          if (challenge && challenge.title) {
            this.challengeTitle = challenge.title
          }
        }
      })
    },
    onRowClick (row) {
      this.$router.push({
        path: '/reports/challenge-campaigns/' + this.challengeId + '/users/' + row.user_id + '/logs',
        query: { title: this.challengeTitle }
      })
    },
    close () {
      this.$bus.$emit('refresh-challenge-report')
      this.$bus.$emit('close-modal')
    }
  }
}
</script>

<style scoped>
.challenge-report-fullscreen-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}
.challenge-report-fullscreen-loader .el-loading-spinner {
  position: static;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ChallengeCampaignUsersReport.vue